<template>
  <transition name="fade" :duration="{enter: 400}">
    <div
      class="text-center mb-14 onborading-box"
      v-if="isShowObb"
    >
      <div v-if="isShowObbTeam">
        <img src="@/assets/images/onboarding/team-presentation.svg" alt="" class="img-onboarding">
        <div class="mb-1 text-xl font-bold">
          {{ $i18nPresenter.t('Create fun and engaging moments, together.') }}
        </div>
        <div class="mb-6 text-base-80">
          <p>
            {{ $i18nPresenter.t('Team presentations created here will be accessible to all team members.') }}
          </p>
        </div>
        <div v-if="!shared">
          <aha-button
            has-margin-right
            variant="primary"
            size="xl"
            class="flex justify-center
            inline-block mb-4 3xs:mr-3
            btn-action-presentation btn-new-presentation-team"
            :class="'ml-auto mr-auto' "
            @click="addNewTeamPresentation()"
          >
            <aha-icon
              name="add"
              width="16"
              height="16"
              viewBox="0 0 24 24"
            />
            <span>{{ $i18nPresenter.t('New Presentation') }}</span>
          </aha-button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import CreateNewPresentationMixin from '@/mixins/presentation/CreateNewPresentationMixin'

export default {
  mixins: [CreateNewPresentationMixin],
  props: {
    shared: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      isImportingSlides: (state) => state.importStatus === 2 || state.importStatus === 3,
      currentUser: (state) => state.currentUser,
    }),
    isShowObb() {
      if (typeof (this.currentUser.isPlayingDemoEnabled) === 'boolean') return true
      if (this.$store.state.plan.group === 'white-label') return true
      return false
    },
    isShowObbTeam() {
      return this.$route.name === 'Team'
    },
    isBothLogicNotTrue() {
      return !this.isShowObb && !this.isShowObbTeam
    },
  },
  watch: {
    isBothLogicNotTrue: {
      handler(value) {
        if (!value) return

        Sentry.captureException('Nash track: Both logic to show onBoardingBox are false', {
          extra: {
            route: this.$route,
          },
        })
      },
    },
  },
  methods: {
    addNewTeamPresentation() {
      this.createNewPresentation('Onboarding Box')
    },
  },
}
</script>

<style lang="scss" scoped>
.img-onboarding {
  margin: 0 auto;
}

@media (max-width: 400px) {
  .btn-action-presentation {
    display: block;
    margin: 0 auto;
    margin-bottom: 20px;
  }
}

@media (max-width: 768px) {
  .onborading-box {
    margin-bottom: 100px;
  }
}
.btn-new-presentation-team {
  width: 173px;
  margin-left: auto;
  margin-right: auto;
}
</style>
